import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import Loader from '../Loader';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';
import variables from '@wix/da-ds/src/styles/variables.scss';
const siteHeaderHeight = parseInt(variables['site-header-height'], 10);
const Drawer = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "notifications_shared" */ './index')));
export const DrawerLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "DrawerLoadable"
    }, /*#__PURE__*/ React.createElement(AbsoluteHeightLayout, {
        heightReduction: siteHeaderHeight
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Loader, {
            type: "drawer-suspense"
        })
    }, /*#__PURE__*/ React.createElement(ModuleLoaderLazy, null), /*#__PURE__*/ React.createElement(Drawer, props))));
};
DrawerLoadable.displayName = 'DrawerLoadable';
export default DrawerLoadable;
